import { defineMessages } from '@jutro/locale';

export default defineMessages({
    vendorsInvolved: {
        id: 'claim.views.claim-detail.claim.views.claim-detail.Vendors involved',
        defaultMessage: 'Vendors involved'
    }
});
